module.exports = __webpack_public_path__ + "site/img/58.50aedbc9.jpg";